import type { RefinancingFormModel } from "web_myplann/Calculators/Types/RefinancingFormModel";
import type { RefinancingPlan } from "web_myplann/Calculators/Types/RefinancingPlan";
import type { RefinancingLeadRequestDTO } from "web_myplann/Infrastructure/Api/Api";
import type { CalculatorPrefill } from "web_myplann/Utils/WebViewModel";

export const mapRefinancingLeadRequest = (
	values: RefinancingFormModel,
	plan: RefinancingPlan & { rate: number },
	prefill?: CalculatorPrefill | null,
): RefinancingLeadRequestDTO => ({
	propertyValue: values.propertyPrice,
	ltv: plan.ltv,
	originalInstallment: values.monthlyPayment,
	originalInterest: values.interest,
	originalPeriod: values.years,
	interest: plan.rate,
	newInstallment: plan.newMonthlyPayment,
	monthlySaving: plan.saving,
	repaymentPeriod: plan.remainingYears,
	sourcePortfolioId: prefill?.contractId,
	sourceContractNumber: prefill?.contractNumber,
	sourceProducer: prefill?.producer,
});
